(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('agendaLabel', [AgendaLabelDirectiveFn]);

    // agenda label directive    
    function AgendaLabelDirectiveFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/agendasettings/modules/agendalabels/templates/agenda-label.template.html',
            controller: 'AgendaLabelController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                label: '=',
                overview: '='
            }
        };
        return directive;

    }

})();